import { gql } from '@apollo/client';

export type FavouriteSupplierTag = {
  pid: string | null;
  name: string | null;
  tagId: string | null;
};

export type FavouriteSupplier = {
  uuid: string;
  name: string | null;
  tags: FavouriteSupplierTag[];
  categoryTier1: string | null;
  public: {
    images: unknown | null;
  } | null;
  dietary: FavouriteSupplierTag[];
  slug: string | null;
  tagline: string | null;
  average_rating: number | null;
};

export type FavouriteSuppliersResponse = {
  favouriteSuppliers: FavouriteSupplier[];
};

export const FAVOURITE_SUPPLIERS = gql`
  query favouriteSuppliers {
    favouriteSuppliers {
      uuid
      name
      tags {
        pid
        name
        tagId
      }
      categoryTier1
      public {
        images
      }
      dietary {
        pid
        name
        tagId
      }
      slug
      tagline
      average_rating
    }
  }
`;
